import { Reveal, Chapter } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const PORTRAIT = "/images/branimir-radosavljevic.webp";

const Founder = () => (
  <section data-testid="founder-section" className="bg-ink text-ivory py-28 lg:py-40">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-14 lg:gap-24 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative">
              <div className="absolute -top-5 -left-5 w-full h-full border border-bronze/40" />
              <div className="relative overflow-hidden">
                <img
                  src={PORTRAIT}
                  alt="Branimir Radosavljevic, Founder and Managing Director of BR Hospitality"
                  className="w-full aspect-[4/5] object-cover object-top hover:scale-[1.03] transition-transform duration-1000"
                  data-testid="founder-portrait"
                />
              </div>
              <div className="mt-6 flex items-baseline justify-between">
                <p className="font-serif text-xl text-ivory">Branimir Radosavljevic</p>
                <p className="text-[10px] tracking-[0.3em] uppercase text-bronze">
                  Founder &amp; Managing Director
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <Chapter number="02" label="The Recruiter's Edge" dark />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.08]">
              Hospitality Experience Behind <span className="italic text-bronze">Every Search</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-ivory/70 font-light leading-relaxed max-w-2xl">
              With more than 15 years of international hospitality leadership experience, Branimir
              Radosavljevic brings an operator&apos;s perspective to hospitality recruitment. His
              career spans luxury hotels, destination restaurants, international pre-openings and
              globally recognized hospitality concepts.
            </p>
            <p className="mt-5 text-ivory/70 font-light leading-relaxed max-w-2xl">
              From pre-opening teams connected with Wolfgang Puck in Dubai to luxury hospitality
              operations across the Middle East and Asia, his experience provides a deep
              understanding of what separates a good candidate from someone capable of shaping a
              hospitality brand.
            </p>
            <p className="mt-5 text-sm text-ivory/50 leading-relaxed max-w-2xl">
              BR Hospitality therefore approaches recruitment from an operational perspective —
              evaluating leadership ability, cultural compatibility, commercial understanding and
              genuine hospitality instinct.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <button
              data-testid="founder-cta-approach"
              onClick={() => scrollToId("#recruitment")}
              className="mt-10 text-[11px] tracking-[0.25em] uppercase px-8 py-4 border border-bronze text-bronze hover:bg-bronze hover:text-ink transition-all duration-500"
            >
              Discover Our Approach
            </button>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Founder;
